<template>
  <PulseProfileAnalysis
    :disable-animation="true"
    :questions="questions"
    :topic-perspectives="perspectivesFromTopic(feedbackTopic)"
  />
</template>

<script setup lang="ts">
  import PulseProfileAnalysis from '@/core/components/analytics/PulseProfileAnalysis.vue'
  import type { PulseQuestionAnalysis } from '@/core/models/surveys-analytics'
  import type { FeedbackTopic } from '@/core/models/feedback-topic'
  import { perspectivesFromTopic } from '@/core/models/perspective'

  interface Props {
    feedbackTopic: FeedbackTopic
    questions: ReadonlyArray<PulseQuestionAnalysis>
  }

  defineProps<Props>()
</script>
